// @flow
import styled, { keyframes } from 'styled-components';

import { Button, HrefButton, LinkButton } from '~/components/widgets/buttons';
import { media } from '~/core/utils/style';
import Modal from 'react-modal';

const buttonContainerHeight = 5;
const deskstopMaxHeight = '86vh';

const reveal = keyframes`
	from { transform: translate3d(-50%, 100%, 0); }
	to { transform: translate3d(-50%, 7vh, 0); }
`;

const revealFullScreen = keyframes`
	from { transform: translate3d(-50%, 100%, 0); }
	to { transform: translate3d(-50%, 0, 0); }
`;

export const StyledModal = styled(Modal)`
    animation: ${p => (p.isBig ? revealFullScreen : reveal)} 0.3s ease-out forwards;
    background-color: ${p => p.theme.white};
    border-radius: ${p => (p.isBig ? 0 : 3)}px;
    box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 13px 19px 2px rgba(0, 0, 0, 0.14),
        0 5px 24px 4px rgba(0, 0, 0, 0.12);
    height: ${p => (p.isBig ? '100%' : 'inherit')};
    left: 50%;
    max-width: 100vw;
    min-width: 20rem;
    outline: none;
    overflow: hidden;
    position: absolute;
    width: ${p => (p.isBig ? '100vw' : 'inherit')};

    ${media.large`
		animation-name: ${reveal};
		height: ${p => (p.isBig ? deskstopMaxHeight : 'inherit')};
		max-height: ${deskstopMaxHeight};
		max-width: 60rem;
	`};
`;

const getHeight = (p, isDesktop) => {
    const nonUsableHeight = p.hasButtons ? buttonContainerHeight : 0;
    return `calc(${isDesktop ? deskstopMaxHeight : '100%'} - ${nonUsableHeight}em)`;
};

export const Content = styled.div`
    height: ${p => (p.isBig ? getHeight(p, false) : 'inherit')};
    overflow-y: auto;
    padding: ${p => (p.noPadding ? 0 : '1em')};

    ${media.large`
			height: inherit;
			max-height: ${p => getHeight(p, true)};
		`};
`;

export const Buttons = styled.div`
    align-items: center;
    bottom: 0;
    box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    height: ${buttonContainerHeight}em;
    justify-content: space-around;
    padding: 1em;
`;

const modalButtonStyles = `
    margin: 0 0.5em;
    padding: 0.75rem 2rem;
    flex-shrink: 0;
    ${media.tablet`
    	margin: 0 1em;
    	padding: 0.75rem 3rem;
    `};
`;

export const ModalButton = styled(Button)`${modalButtonStyles};`;

export const ModalHrefButton = styled(HrefButton)`${modalButtonStyles};`;

export const ModalLinkButton = styled(LinkButton)`${modalButtonStyles};`;

// Unfortunately we cannot use styled component for the overlay
// as react-modal only accepts inline styling
export const overlayStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    transition: 'background-color 0.3s',
    zIndex: 999 // 1 less than the alerts
};



// WEBPACK FOOTER //
// ./src/components/widgets/modal/style.js